import React, {useState, useEffect, useMemo} from 'react'
import {default as Apiservices} from '../../../../src/common/index'
import {useNavigate} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {useForm} from 'react-hook-form'
import BackDrop from '../../modules/apps/timesheetentry/ComponentBackdrop'
import 'react-datepicker/dist/react-datepicker.css'
import Cookies from 'universal-cookie'
import {Tooltip} from '../../modules/apps/timesheetentry/ComponentTooltip'

type FormData = {
  old_password: string
  new_password: string
  confirm_password: string
}
export default function ResetPassword(props: any) {
  const navigate = useNavigate()
  const [show, setShow] = useState(true)
  const cookies = new Cookies()
  const [showBackDrop, setShowBackDrop] = useState(false)
  const {
    register,
    setValue,
    reset,
    handleSubmit,
    getValues,
    formState: {errors},
  } = useForm<FormData>()

  const handleClose = () => {
    setShow(false)
    props.close(false)
    props.setShow(false)
  }
  const [ConfirmError, setConfirmError] = useState('')
  const [ConfirmError1, setConfirmError1] = useState(false)
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const showOldPasswordHandler = () => {
    setShowOldPassword(!showOldPassword)
  }
  const showNewPasswordHandler = () => {
    setShowNewPassword(!showNewPassword)
  }
  const showPasswordHandler = () => {
    setShowPassword(!showPassword)
  }
  const onSubmit = async (data: FormData) => {
    setShowBackDrop(true)
    const article = {
      oldPassword: data.old_password,
      newPassword: data.new_password,
      confirmPassword: data.confirm_password,
      selectedUserId: parseInt(localStorage.getItem('ecdb_user_id') || '0', 10),
    }
    if (!ConfirmError1) {
      const res: any = await Apiservices.getChangePassword(article)
      if (res.statusCode == 200) {
        toast.success(res.message)
        logout()
      } else if (res.errorCode == 500) {
        toast.error(res.message)
      } else {
        toast.error(res.message)
      }
    }
    setShowBackDrop(false)
  }
  function removeAll() {
    let lRemove: any = [
      'token',
      'user_email',
      'org_list',
      'role_Name',
      'org_prefix',
      'org_id',
      'org_name',
      'tool_name',
      'ecdb_user_id',
      'userid',
      'Authorization',
      'NetSuiteToken',
      'enable_netsuite',
      'subsidary_name',
      'logged_in_id',
      'Announcement',
      'refresh_Token',
      'enable_quickbooks',
      'org_icon',
      'time_sheet_admin_screen_user_id',
      'MobileForceUpdateAccessbyEmail',
      'allowed_business_unit_id',
      'bu_list',
      'enable_unbilled',
      'invoice_access',
      'enable_email',
      'passwordExpiryDays',
      'passwordPopUpDays',
      'support',
      'is_pending_timesheet_submission',
      'is_timesheet_approval',
      'is_timesheet_rejection',
      'is_timesheet_reminder',
      'is_timesheet_submission',
    ]
    for (let each of lRemove) {
      localStorage.removeItem(each)
    }
  }
  const logout = async () => {
    const data: any = await Apiservices.getUserLogout()
    const data1: any = await Apiservices.getUserLogout1()
    if (data.data.statusCode == 200 || data1.status == 200) {
      removeAll()
      cookies.remove('JWT-TOkEN')
      cookies.remove('JWT_TOKEN')
      cookies.remove('org_id')
      cookies.remove('torg_id')
      cookies.remove('profileView')
      cookies.remove('tool_name')
      cookies.remove('ecdb_user_id')
      localStorage.setItem('business_unit_id', '')
      cookies.remove('JWT-TOkEN', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('JWT_TOKEN', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('org_id', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('torg_id', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('profileView', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('tool_name', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('ecdb_user_id', {path: '/', domain: '.msrcosmos.com'})
      let consultant: any = {name: 'Manage Consultants'}
      sessionStorage.setItem('consultant', JSON.stringify(consultant))
      let project: any = {name: 'Manage Projects'}
      sessionStorage.setItem('project', JSON.stringify(project))
      return (
        toast.success('Logout Successful'),
        {
          position: toast.POSITION.BOTTOM_LEFT,
        },
        setTimeout(function () {
          navigate('/login')
        }, 1000)
      )
    }
  }

  const handleConfirmPassword = (new1: any, confirm1: any) => {
    setConfirmError('')
    if (new1 && confirm1) {
      if (new1 == confirm1) {
        setConfirmError1(false)
        setConfirmError('')
      } else {
        setConfirmError1(true)
        setConfirmError("Password Doesn't Match")
      }
    }
  }
  const handleNewPassword = (new1: any, confirm1: any) => {
    setConfirmError('')

    if (new1 && confirm1) {
      if (new1 == confirm1) {
        setConfirmError1(false)
        setConfirmError('')
      } else {
        setConfirmError1(true)
        setConfirmError("Password Doesn't Match")
      }
    }
  }
  const expiryDays: number = parseInt(localStorage.getItem('passwordExpiryDays') || '0', 10)
  const expiryDays1 = 180 - expiryDays
  const passwordPopUpDays = parseInt(localStorage.getItem('passwordPopUpDays') || '0', 10)
  const passwordExpiryDays = parseInt(localStorage.getItem('passwordExpiryDays') || '0', 10)
  const isPassKey = passwordPopUpDays - passwordExpiryDays
  const isPassKey1 = passwordPopUpDays == passwordExpiryDays
  return (
    <>
      <BackDrop showBackDrop={showBackDrop} />
      <Modal
        show={show}
        // onHide={handleClose}
        // size='lg'
        // fullscreen={fullscreen}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        backdrop='static'
      >
        {props.view_open && (
          <div className='col-auto'>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={props.cancel}
            ></button>
          </div>
        )}
        <Modal.Header>
          <Modal.Title>
            {isPassKey1 || passwordPopUpDays < passwordExpiryDays
              ? 'Your password has expired. Please reset it to regain access to your account.'
              : `Your password expires in ${isPassKey} days. Please update it now to keep your account active.`}
          </Modal.Title>
          {passwordExpiryDays < passwordPopUpDays && (
            <button
              type='button'
              className='btn-close'
              onClick={props.forcePasswordPopClose}
              data-bs-dismiss='modal'
              aria-label='Close'
            ></button>
          )}
        </Modal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <>
              <label className='form-label'>Old Password *</label>
              <div className='form-floating'>
                <input
                  //   type='text'
                  type={showOldPassword ? 'text' : 'password'}
                  className='form-control fs-6'
                  placeholder='Enter old password'
                  {...register('old_password', {
                    required: true,
                    // onChange: (e) => {
                    //   handlePlacement(e.target.value)
                    // },
                  })}
                />
                {showOldPassword ? (
                  <Tooltip text='Hide Password'>
                    <i
                      className={`bi fs-3 bi-eye viewPassword ${
                        errors.old_password ? 'is-invalid' : ''
                      }`}
                      onClick={showOldPasswordHandler}
                    ></i>
                  </Tooltip>
                ) : (
                  <Tooltip text='View Password'>
                    <i
                      className={`bi fs-3 bi-eye-slash viewPassword ${
                        errors.old_password ? 'is-invalid' : ''
                      }`}
                      onClick={showOldPasswordHandler}
                    ></i>
                  </Tooltip>
                )}
                {errors.old_password && errors.old_password.type === 'required' && (
                  <p className='error text-danger mb-0'>Old password is required.</p>
                )}
              </div>
              <br />
              <label className='form-label'>New Password *</label>
              <div className='form-floating'>
                <input
                  //   type='text'
                  type={showNewPassword ? 'text' : 'password'}
                  className='form-control fs-6'
                  placeholder='Enter new password'
                  {...register('new_password', {
                    required: true,
                    pattern: {
                      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,15}$/,
                      message:
                        'Minimum 8 characters with atleast one uppercase, lowercase, numeric and special character',
                    },
                    onChange: (e) => {
                      handleNewPassword(e.target.value, getValues('confirm_password'))
                    },
                  })}
                />
                {showNewPassword ? (
                  <Tooltip text='Hide Password'>
                    <i
                      className={`bi fs-3 bi-eye viewPassword ${
                        errors.new_password ? 'is-invalid' : ''
                      }`}
                      onClick={showNewPasswordHandler}
                    ></i>
                  </Tooltip>
                ) : (
                  <Tooltip text='View Password'>
                    <i
                      className={`bi fs-3 bi-eye-slash viewPassword ${
                        errors.new_password ? 'is-invalid' : ''
                      }`}
                      onClick={showNewPasswordHandler}
                    ></i>
                  </Tooltip>
                )}
                {errors.new_password && errors.new_password.type === 'required' && (
                  <p className='error text-danger mb-0'>New password is required.</p>
                )}
                {errors.new_password?.type === 'pattern' && (
                  <p className='text-danger mb-0'>{errors.new_password.message}</p>
                )}
              </div>
              <br />
              <label className='form-label'>Confirm Password *</label>
              <div className='form-floating'>
                <input
                  //   type='text'
                  //   id='floatingPassword'
                  className='form-control fs-6'
                  placeholder='Confirm password'
                  type={showPassword ? 'text' : 'password'}
                  {...register('confirm_password', {
                    required: true,
                    // pattern: {
                    //   value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,15}$/,
                    //   message:
                    //     'Minimum 8 characters with atleast one uppercase, lowercase, numeric and special character',
                    // },
                    onChange: (e) => {
                      handleConfirmPassword(getValues('new_password'), e.target.value)
                    },
                  })}
                />
                {showPassword ? (
                  <Tooltip text='Hide Password'>
                    <i
                      className={`bi fs-3 bi-eye viewPassword ${
                        errors.confirm_password ? 'is-invalid' : ''
                      }`}
                      onClick={showPasswordHandler}
                    ></i>
                  </Tooltip>
                ) : (
                  <Tooltip text='View Password'>
                    <i
                      className={`bi fs-3 bi-eye-slash viewPassword ${
                        errors.confirm_password ? 'is-invalid' : ''
                      }`}
                      onClick={showPasswordHandler}
                    ></i>
                  </Tooltip>
                )}
                {errors.confirm_password && errors.confirm_password.type === 'required' && (
                  <p className='error text-danger mb-0'>Confirm password is required.</p>
                )}
                {/* {errors.confirm_password?.type === 'pattern' && (
                  <p className='text-danger mb-0'>{errors.confirm_password.message}</p>
                )} */}
                {ConfirmError1 && <p className='error text-danger mb-0 mt-2'>{ConfirmError}</p>}
              </div>
            </>
          </Modal.Body>
          <Modal.Footer className='p-2 py-3'>
            <div className='row justify-content-end  '>
              <div className='col-auto'>
                <button
                  type='submit'
                  className='btn btn-sm btn-primary'
                  // onClick={props.forcePasswordPopClose}
                >
                  Reset
                </button>
              </div>

              {passwordExpiryDays < passwordPopUpDays && (
                <div className='col-auto'>
                  <button
                    type='button'
                    className='btn btn-sm btn-primary'
                    onClick={props.forcePasswordPopClose}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </Modal.Footer>
        </form>
      </Modal>
      <ToastContainer />
    </>
  )
}
